var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewMenuBlog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_426_2825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0624 13.2278C25.0286 13.9144 24.5076 14.7622 23.6681 15.577V26.3143C23.6671 26.5908 23.5582 26.8252 23.3742 27.0083C23.1893 27.1878 22.9494 27.2939 22.6674 27.2958H5.16895C4.88881 27.2939 4.64799 27.1877 4.46307 27.0083C4.27903 26.8252 4.17104 26.5908 4.1701 26.3143V9.15548C4.17104 8.87992 4.27903 8.64461 4.46307 8.4615C4.64799 8.28203 4.88881 8.17586 5.16895 8.17404H14.4625C15.2141 7.18709 16.0903 6.17634 17.0827 5.24986C17.0873 5.24435 17.091 5.23884 17.0956 5.2334H5.16895C4.07032 5.23246 3.06051 5.67466 2.3418 6.38148C1.61946 7.0883 1.16899 8.07707 1.16992 9.15554V26.3144C1.16899 27.3928 1.61946 28.3835 2.3418 29.0884C3.06045 29.7951 4.07032 30.2364 5.16895 30.2364H22.6675C23.7679 30.2364 24.7778 29.7951 25.4964 29.0883C26.217 28.3834 26.6683 27.3927 26.6674 26.3143V12.1584C26.6674 12.1584 26.6601 12.1493 26.6482 12.1401C26.1931 12.5301 25.663 12.9018 25.0624 13.2278Z",
    fill: "url(#paint0_linear_426_2825)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.573 0.237305C29.573 0.237305 28.6538 1.61062 22.6498 3.64212C16.5276 5.714 12.7593 14.1424 12.7593 14.1424C11.852 15.8691 8.26584 23.0431 8.26584 23.0431C7.27801 24.8961 9.08797 25.9911 10.15 24.0776C12.1852 20.4045 13.499 17.0482 16.5935 16.953C21.108 16.8138 24.1951 12.8716 23.2237 13.0547C21.9456 13.6113 19.1277 13.0968 20.7875 12.8405C24.7719 12.521 27.2273 9.52623 26.4272 9.32302C25.0145 9.86683 23.6971 9.3505 23.4389 9.19482C30.4711 8.3397 29.573 0.237305 29.573 0.237305Z",
    fill: "url(#paint1_linear_426_2825)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_426_2825",
    x1: 4.38344,
    y1: -10.1775,
    x2: 33.8148,
    y2: -4.0404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_426_2825",
    x1: 10.7065,
    y1: -15.0748,
    x2: 35.9586,
    y2: -10.5791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_426_2825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 31,
    fill: "white",
    transform: "translate(0.605469 0.174805)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMenuBlog);
export default __webpack_public_path__ + "static/media/new-menu-blog.d1d4f9912b526a5b2cb968ca201ed820.svg";
export { ForwardRef as ReactComponent };